class TasksController {
  constructor($state, $stateParams) {
    'ngInject'; // Tasks will be sortable

    Object.assign(this, {
      $state,
      $stateParams,
      serviceCode: $stateParams.serviceCode,
      tasks: [{
        name: 'Questionnaire',
        route: 'cms.questionnaire'
      }]
    });
  }

}

TasksController.$inject = ["$state", "$stateParams"];
angular.module('pims').controller('TasksController', TasksController);